import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchInput from "../../Components/SearchInput";
import Button from "../../Components/Button/Button";
import { serviceConsumer } from "../../network/ServiceConsumer";
import Loader from "../../Components/Loader/Loader";
import SingleLineTitle from "../../Components/TitleElements/SingleLineTitle";
import { v4 as uuidv4 } from "uuid";

// Big enough to pull the whole list in one request when "Show All" is used.
const LOAD_ALL = 100000;

const ManageDancers = () => {
  const [loading, setLoading] = useState(false);
  const [dancerData, setDancerData] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [hasFetched, setHasFetched] = useState(false);
  const [lastQuery, setLastQuery] = useState("");
  const navigate = useNavigate();

  // Nothing loads on arrival — the admin searches, or asks for everyone.
  const fetchList = async (searchVal = lastQuery) => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_BASE_URL}/api/admin/list-dancers`;
      const payload = { page: 1, limit: LOAD_ALL, searchKey: searchVal };
      const response = await serviceConsumer("POST", url, payload);
      setDancerData(response.date);
      setHasFetched(true);
      setLastQuery(searchVal);
    } catch (error) { }
    setLoading(false);
  };

  const submitSearch = (e) => {
    if (e) e.preventDefault();
    if (!searchInput.trim()) return;
    fetchList(searchInput.trim());
  };

  const showAll = () => {
    setSearchInput("");
    fetchList("");
  };

  const backToDashboardHandler = () => {
    localStorage.setItem("eventsTab", false);
    navigate("/");
  };

  const hasData = dancerData?.list?.length > 0;

  return (
    <>
      <SingleLineTitle titleName="Dancers" onBackClick={backToDashboardHandler} />
      <div className="db-body">
        {loading && <Loader />}
        <form onSubmit={submitSearch} className="d-flex flex-column flex-md-row align-items-md-center pt-3" style={{ gap: "10px" }}>
          <div className="col-sm-8 col-md-4">
            <SearchInput searchInput={searchInput} setSearchInput={setSearchInput} />
          </div>
          <Button type="submit" className={searchInput.trim() ? "filled" : "disabled"}>Search</Button>
          <Button type="button" className="outlined" onClick={showAll}>Show All</Button>
          {hasFetched && <div className="competitor-count ms-md-2">{dancerData?.resultCount || 0}</div>}
        </form>

        {!hasFetched && !loading && (
          <div className="d-flex justify-content-center my-5 text-center" style={{ color: "#797979" }}>
            Search for a dancer by name or school — or use “Show All” to load every dancer.
          </div>
        )}

        {hasData && (
          <div style={{ width: "100%", overflowX: "scroll", marginTop: "30px", marginBottom: "50px" }}>
            <table className="table my_table competitorTable">
              <tbody>
                <tr className="header-row">
                  <td className="mx-5 w-3 p-25 text-center">S.No</td>
                  <td className="mx-5 w-8 p-25">First Name</td>
                  <td className="mx-5 w-8 p-25-5">Last Name</td>
                  <td className="mx-5 w-8 p-25-5">School</td>
                  <td className="mx-5 w-8 p-25-5">DOB</td>
                  <td className="mx-5 w-10 p-25-5">Parent Email</td>
                </tr>
                {dancerData?.list?.map((dancer, index) => (
                  <tr
                    key={dancer?._id || uuidv4()}
                    style={{ fontSize: "12px", height: "61px", cursor: "pointer" }}
                    onClick={() => navigate(`/dancers/details/${dancer._id}`, { state: { dancerName: `${dancer.fname} ${dancer.lname}` } })}
                  >
                    <td className="mx-5 w-3 p-25 text-center">{index + 1}</td>
                    <td className="mx-5 w-8 p-25"><span style={{ color: "#68ad3f", cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); navigate(`/dancers/details/${dancer._id}`, { state: { dancerName: `${dancer.fname} ${dancer.lname}` } }); }}>{dancer?.fname}</span></td>
                    <td className="mx-5 w-8 p-25-5"><span style={{ color: "#68ad3f", cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); navigate(`/dancers/details/${dancer._id}`, { state: { dancerName: `${dancer.fname} ${dancer.lname}` } }); }}>{dancer?.lname}</span></td>
                    <td className="mx-5 w-8 p-25-5">{dancer?.school || "N/A"}</td>
                    <td className="mx-5 w-8 p-25-5">{dancer?.birthday || "N/A"}</td>
                    <td className="mx-5 w-10 p-25-5">{dancer?.parentData?.email || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!loading && hasFetched && dancerData?.list?.length === 0 && (
          <div className="d-flex justify-content-center my-5">
            {lastQuery ? `No dancers match “${lastQuery}”.` : "No dancers found"}
          </div>
        )}
      </div>
    </>
  );
};

export default ManageDancers;
